import "./SelectClaimType.css";

interface EmptyPageProps {
  height: number;
  text: string |React.ReactNode;
  imgSrc?: any;
  button?: React.ReactNode; 
}

const EmptyPage: React.FC<EmptyPageProps> = ({ height, text, imgSrc ,button}) => {
  return (
    <div className="selectClaimTypeContainer" style={{ height: `${height}%` }}>
      <div className="subContainer">
        <img className="emptyPageImg" src={imgSrc}  />
        <p className="emptyPageText">{text}</p>
        {button && <div className="emptyPageButton">{button}</div>}
      </div>
    </div>
  );
};

export default EmptyPage;
